var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 3C13.25 2.58579 13.5858 2.25 14 2.25C18.2802 2.25 21.75 5.71979 21.75 10C21.75 10.4142 21.4142 10.75 21 10.75C20.5858 10.75 20.25 10.4142 20.25 10C20.25 6.54822 17.4518 3.75 14 3.75C13.5858 3.75 13.25 3.41421 13.25 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5578 14.4796L18.0721 13.551C17.1862 12.9973 16.0224 13.2284 15.4152 14.0785C14.948 14.7325 14.2274 15.1967 13.4506 14.99C12.7333 14.7991 11.7649 14.3426 10.7112 13.2888C9.65743 12.2351 9.20087 11.2667 9.00997 10.5494C8.80326 9.77263 9.26746 9.05196 9.9215 8.58479C10.7716 7.97756 11.0027 6.81377 10.449 5.92785L9.52045 4.44223C8.59347 2.95907 6.616 2.54986 5.17653 3.5433L4.65012 3.9066C3.68099 4.57544 2.95708 5.57013 3.00198 6.7468C3.07885 8.76118 3.89449 12.2567 7.81887 16.1811C11.7433 20.1055 15.2388 20.9211 17.2532 20.998C18.4299 21.0429 19.4246 20.319 20.0934 19.3499L20.4567 18.8235C21.4501 17.384 21.0409 15.4065 19.5578 14.4796Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.25C13.5858 5.25 13.25 5.58579 13.25 6C13.25 6.41421 13.5858 6.75 14 6.75C15.795 6.75 17.25 8.2051 17.25 10C17.25 10.4143 17.5858 10.75 18 10.75C18.4143 10.75 18.75 10.4143 18.75 10C18.75 7.37667 16.6234 5.25 14 5.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneRing);
export default __webpack_public_path__ + "static/media/phone-ring.a357780f98e2a6365ed336dd6037ef7c.svg";
export { ForwardRef as ReactComponent };